import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';

const localHeaderSwiper = () => {
  const localHeaderCarousels = document.querySelectorAll(
    '.local-header__carrousel'
  );

  if (0 < localHeaderCarousels.length) {
    localHeaderCarousels.forEach(function (localHeaderCarousel) {
      const swiperConfig = {
        slidesPerView: 1,
        loop: true,
        navigation: {
          nextEl: localHeaderCarousel.querySelector('.swiper-button-next'),
          prevEl: localHeaderCarousel.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: '.swiper-pagination--header-local',
          clickable: true,
        },
      };
      new Swiper(localHeaderCarousel, swiperConfig);
    });
  }
};

domReady(() => {
  localHeaderSwiper();
});
